// V4-FRONT-GUEST-NAV-GATING-TEST 2026-06-15
// Source UNIQUE du filtrage des items de navigation par rôle/onboarding, partagée
// par la Sidebar desktop (`Sidebar.tsx`) et le menu burger mobile (`MobileBurgerMenu.tsx`).
// Avant : la logique était dupliquée inline dans les deux composants → le burger mobile
// ne filtrait que `isReadOnly` (pas `isGuest`), laissant un guest voir tout le menu sur
// mobile. Centraliser ici garantit la parité desktop/mobile + rend la règle testable.

import { SIDEBAR_ITEMS } from './Constants';

export interface NavFilterOptions {
  /** Compte invité lecture seule : ne voit QUE Engagement, toute la config masquée. */
  isGuest: boolean;
  /** Viewer/lecture seule (agence) : masque Automatisations. */
  isReadOnly: boolean;
  /** Owner d'agence (pour décider l'affichage de l'item Espaces sur mobile). */
  isAgencyOwner: boolean;
  /** Positionnement défini → débloque les items gatés par l'onboarding. */
  topicsUnlocked: boolean;
  /** Lecteur d'agence : jamais bloqué par l'onboarding séquentiel. */
  onboardingReadOnly: boolean;
  /** Items masqués tant que le positionnement n'est pas rempli. */
  positioningGatedItems: string[];
  /**
   * Desktop (`Sidebar`) masque TOUJOURS Espaces de la nav principale (`false`).
   * Mobile (`MobileBurgerMenu`) l'affiche si l'utilisateur est owner d'agence (`true`).
   */
  showSpacesWhenOwner: boolean;
}

/**
 * Filtre une liste d'items de nav selon le rôle + l'état d'onboarding.
 * Règle GUEST prioritaire : un invité ne voit que `ENGAGEMENT`, jamais la config.
 */
export function filterNavItems<T extends { id: string }>(
  items: T[],
  o: NavFilterOptions,
): T[] {
  return items.filter((item) => {
    // GUEST (invité lecture seule) : surface réduite à Engagement uniquement.
    if (o.isGuest) return item.id === SIDEBAR_ITEMS.ENGAGEMENT;
    if (item.id === SIDEBAR_ITEMS.SPACES) {
      return o.showSpacesWhenOwner ? o.isAgencyOwner : false;
    }
    if (o.isReadOnly && item.id === SIDEBAR_ITEMS.AUTOMATIONS) return false;
    if (
      !o.onboardingReadOnly &&
      !o.topicsUnlocked &&
      o.positioningGatedItems.includes(item.id)
    ) {
      return false;
    }
    return true;
  });
}

/** Settings masqué pour un guest (aucune configuration accessible). */
export function shouldShowSettingsItem(isGuest: boolean): boolean {
  return !isGuest;
}
